import { AuthModel } from '@/models/UserModel';
import { deepFreeze } from '@/utils/common-utils';

export class AuthService {
  private authModel: AuthModel | null = null;

  public get auth(): AuthModel | null {
    return this.authModel;
  }

  public setAuth(authModel: AuthModel | null): void {
    this.authModel = authModel ? deepFreeze<AuthModel>(authModel) : null;
  }
}
